export function hasNoVisibleModal () {
  return window.currentVisibleShortcutModalUid === undefined
}
